import React, { useState } from "react";
import { Tab } from "semantic-ui-react";
import { ListEmployees } from "../../../components/Admin/Employees";
import { useLanguage } from "../../../contexts";
import "./Employees.scss";

export function Employees() {
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;
  const [reload, setReload] = useState(false);
  const onReload = () => setReload((prev) => !prev);

  const panes = [
    {
      menuItem: t("active_employees"),
      render: () => (
        <Tab.Pane attached={false}>
          <ListEmployees active={true} reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: t("inactive_employees"),
      render: () => (
        <Tab.Pane attached={false}>
          <ListEmployees active={false} reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <div className="employees-page" style={{ padding: "0 0 1.5rem" }}>
      <div className="employees-page-header-wrapper">
        <div className="employees-page-header">
          <span className="employees-page-title">{t("employees")}</span>
        </div>
      </div>
      <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
    </div>
  );
}
